import React, { useState } from 'react';
import { navigate } from 'gatsby';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
// import spriteImage from "../../assets/images/sprite-steps2.png";
import { BasicButton } from '../Buttons/BasicButton';

const StyledBox = styled.div`
  height: max-content;
  width: 210px;
  padding: 25px;
  border-radius: 20px;

  &:hover {
    background-color: #f2f1f2;
  }

  @media (max-width: 576px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

const playKeyframe = (steps) => keyframes`
  from {
    background-position: 0;
  }
  to {
  background-position: ${(steps - 1) * -70}px;
  }
`;

const playKeyframeOut = (steps) => keyframes`
  from {
    background-position: ${(steps - 1) * -70}px;
  }
  to {
    background-position: 0;
  }
`;

const SpriteImage = styled.div`
  height: 70px;
  width: 70px;
  background: url(${(props) => props.imgSrc}) left top;
  background-size: cover;
  margin-bottom: 15px;

  animation: ${(props) => playKeyframeOut(props.steps)} 1s steps(${(props) => props.steps - 1})
    forwards;

  &.hover {
    animation: ${(props) => playKeyframe(props.steps)} 1s steps(${(props) => props.steps - 1})
      forwards;
  }
`;

const StyledTitle = styled.p`
  height: 72px;
  width: 177px;
  color: #3c3c3c;
  font-family: Avenir;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 0.18px;
  line-height: 36px;
  margin: 0;

  @media (max-width: 576px) {
    text-align: center;
  }
`;

const StyledLine = styled.hr`
  box-sizing: border-box;
  height: 1px;
  border: 1px solid #1c1c1c;
  margin: 15px 0;
  width: 100%;
`;

const ButtonDiv = styled.div`
  :hover {
    cursor: pointer;
  }
`;

const ServiceCard = ({ imgSrc, title, to, state, steps }) => {
  const [hoverState, setHoverState] = useState(false);
  const toggleHover = () => {
    setHoverState(!hoverState);
  };
  return (
    <StyledBox onMouseEnter={toggleHover} onMouseLeave={toggleHover}>
      <SpriteImage className={hoverState ? 'hover' : ''} imgSrc={imgSrc} steps={steps} />
      <StyledTitle>{title}</StyledTitle>
      <StyledLine />
      <ButtonDiv
        onClick={() => {
          localStorage.setItem('selectedOption', state.selected);
          navigate(to, { state: state });
        }}>
        <BasicButton text='Read More' />
      </ButtonDiv>
    </StyledBox>
  );
};

ServiceCard.defaultProps = {
  icon: '../../assets/images/qa.svg',
  title: 'Quality Assurance',
  to: '/',
  state: {},
};

ServiceCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  to: PropTypes.string,
  state: PropTypes.object,
};

export { ServiceCard };
